














































































import { Component, Vue, Watch } from "vue-property-decorator";
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import DeleteModal from "@/components/DeleteModal.vue";
import HelpCenterModule from "@/store/modules/help-center";
import { entriesHeader } from "@/helpers/help-center/categories-entries-data-tables";
import { footerProps } from "@/helpers/footer-props";
import { genericAdvisory } from "@/helpers/warning-advisory-text";
// eslint-disable-next-line sort-imports
import { namespace, State } from "vuex-class";
import { Entry } from "@/models/help-center/Entry";
import { HelpCenterState } from "@/models/store/HelpCenterState";
import { Pagination } from "@/models/help-center/Pagination";
import { formatDate } from "@/helpers/functions/format-date";
import { truncateContent } from "@/helpers/functions/truncate-content";

const helpCenter = namespace(HelpCenterModule.name);

@Component({
  name: "Entries",
  components: { ApplicationLayout, DeleteModal }
})
export default class Entries extends Vue {
  // ===== Store ===== //
  @State("helpCenter") private readonly helpCenter!: HelpCenterState;
  @helpCenter.Action("deleteEntry") public deleteEntry!: (id: number) => void;
  @helpCenter.Action("getAllCategories") public getAllCategories!: () => void;
  @helpCenter.Action("getAllEntries") public getAllEntries!: () => void;
  @helpCenter.Action("getIndividualEntry") public getIndividualEntry!: (id: string) => void;
  @helpCenter.Action("handleSetEntryPagination") public handleSetEntryPagination!: (payload: Pagination) => void;

  // ===== Data ===== //
  public advisory = genericAdvisory;
  public headers = entriesHeader;
  public footer = footerProps;
  public deleteEntryModal = false;
  public selectedEntry: Entry | null = null;
  public entryLoading = false;

  // ===== Methods ===== //
  public formatDate = formatDate;
  public truncateContent = truncateContent;
  public async handleDeleteEntry(): Promise<void> {
    await this.deleteEntry(this.selectedEntry!.id);
    this.selectedEntry = null;
    this.deleteEntryModal = false;
  }
  public async handleGetIndividualEntry(entryId: string): Promise<void> {
    await this.getIndividualEntry(entryId);
    this.$router.push({ name: "helpCenterEntryEdit", params: { entryId: entryId } });
  }
  public openDelete(entry: Entry): void {
    this.deleteEntryModal = true;
    this.selectedEntry = entry;
  }

  // ===== Watchers ===== //
  /* istanbul ignore */
  @Watch("pagination", { deep: true })
  public handleEntries(): void {
    this.getAllEntries();
  }

  // ===== Computed ===== //
  get entries(): Entry[] {
    return this.helpCenter.entries.list;
  }
  get loadingState(): string[] {
    return this.helpCenter.loadingState;
  }
  get noDataText(): string {
    return this.loadingState.includes("getting all help center entries")
      ? "Retrieving help center entries..."
      : "No entries found";
  }
  get pagination(): Pagination {
    return this.helpCenter.entries.pagination;
  }
  set pagination(newVal: Pagination) {
    this.handleSetEntryPagination(newVal);
  }

  // ===== Lifecycle Hook ===== //
  private mounted(): void {
    this.getAllCategories();
  }
}
